const Mark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#171717" stroke="rgba(212,175,55,0.4)" />
    <circle cx="32" cy="15" r="3" fill="#d4af37" />
    <path d="M17 27 Q32 10 47 27" stroke="#d4af37" strokeWidth="4" fill="none" strokeLinecap="round" />
    <path d="M16 30 h32 v6 a12 12 0 0 1 -12 12 h-8 a12 12 0 0 1 -12 -12 z" fill="#d4af37" />
    <path d="M9 30 h7 M48 30 h7" stroke="#d4af37" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

const Logo = () => (
  <a href="#top" data-testid="logo-link" className="group flex items-center gap-3">
    <Mark />
    <span className="leading-none">
      <span className="block font-display text-lg font-semibold tracking-wide text-stone-50 transition-colors group-hover:text-brand-brass">
        Revathy Stores
      </span>
      <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.28em] text-stone-500">
        Besant Nagar · Chennai
      </span>
    </span>
  </a>
);

export default Logo;
